module.exports = __webpack_public_path__ + "static/media/-_Time Management.c448680d.png";